var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-filter-container"},[(_vm.isMobile)?_c('div',{staticClass:"t-btn _gray t-filter-container__btn",on:{"click":_vm.toggleFiltersVisible}},[_c('span',[_vm._v(_vm._s(_vm.nameBtn))])]):_vm._e(),_vm._v(" "),_c('filter-cmp',{class:{show: _vm.isVisibleFilters},attrs:{"filter":_vm.filter,"form-name":_vm.formName,"is-filter-date":_vm.isFilterDate,"is-reset-filter":_vm.isResetFilter},on:{"close":_vm.toggleFiltersVisible}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/ui-components/filter-container/filter-container.vue?vue&type=template&id=01e0c0b6&
// module id = 959
// module chunks = 0